import { atom } from 'jotai';

const filtersAtom = atom({
  cdn: '',
  asn: '',
  dma: '',
  policy: '',
  triggerKpi: '',
  blacklistedKpi: '',
  blackListCondition: '=',
  duration: '',
  durationCondition: '=',
  referenceKpi: '',
  referenceCondition: '=',
  kpiSampleSize: '',
  sampleSizeCondition: '=',
});

export default filtersAtom;
